import {
  ConsentOrdersYourIncomeSchema,
  InitialDetails,
  RadioSelect,
  Select,
  TextArea,
  TextInput,
  UserIncomeIcon,
  useOptions
} from "@fla/components";
import { yupResolver } from "@hookform/resolvers/yup";
import { selectConsentOrdersBase } from "pages/ConsentOrders";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

interface IProps {
  formId: string;
  store: InitialDetails;
  onSubmit: (values: InitialDetails) => void;
}

export default function YourIncome({ onSubmit, formId, store }: IProps) {
  const { initialDetails } = useSelector(selectConsentOrdersBase);

  const { binaryWithOtherList } = useOptions({ initialDetails });

  const { handleSubmit, control, watch } = useForm({
    mode: "all",
    defaultValues: store,
    resolver: yupResolver(ConsentOrdersYourIncomeSchema)
  });

  return (
    <form id={formId} className="space-y-5" onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-8 pb-8 border-b">
        <UserIncomeIcon classes="w-14 h-14 mx-auto mb-5" />

        <h3 className="text-center">Your Current Income</h3>
      </div>

      <TextInput
        title="Your Gross weekly income (before tax)"
        subTitle="Estimates are fine"
        control={control}
        name="user.user_income_now"
        id="user.user_income_now"
        placeholder="Amount"
        isAmount
        wrapClasses="w-fit"
      />

      <RadioSelect
        title="Will the result of the Consent Orders you are seeking affect your earning capacity?"
        subTitle="E.g. are you acquiring or disposing of a business or investment of significant value?"
        control={control}
        name="user.affect_earning_user"
        id="user.affect_earning_user"
        options={["yes", "no"]}
        classes="col-span-1"
      />
      {watch("user.affect_earning_user") === "yes" ? (
        <TextArea
          title="Please give further details how it will affect your earning capacity"
          control={control}
          name="user.affect_earning_user_details"
          id="user.affect_earning_user_details"
          placeholder="details"
        />
      ) : null}

      <RadioSelect
        title={
          <>
            Are you <span className="underline underline-offset-4">paying</span>
            &nbsp;child support?
          </>
        }
        control={control}
        name="user.user_if_paying_cs"
        id="user.user_if_paying_cs"
        options={["yes", "no"]}
      />

      {watch("user.user_if_paying_cs") === "yes" ? (
        <article className="grid grid-cols-2 gap-x-4">
          <Select
            // title={<p className="font-bold text-md col-span-2">Paid to:</p>}
            title="Paid to:"
            control={control}
            name="user.user_cs_payment_to"
            id="user.user_cs_payment_to"
            placeholder="Payment to"
            options={binaryWithOtherList}
          />

          <TextInput
            // title={
            //   <p className="font-bold text-md col-span-2">
            //     Weekly Payment Amount
            //   </p>
            // }
            title="Weekly Payment Amount"
            control={control}
            name="user.user_cs_payment_amount"
            id="user.user_cs_payment_amount"
            placeholder="Amount"
            isAmount
          />
        </article>
      ) : null}

      {watch("user.user_if_paying_cs") === "yes" && watch("user.user_cs_payment_to") === "other" ? (
        <article className="grid grid-cols-2 gap-x-4">
          <p className="font-bold text-sm mb-2 col-span-2">Payment to:</p>
          <TextInput
            title={null}
            control={control}
            name="user.user_cs_payment_other.first_name"
            id="user.user_cs_payment_other.first_name"
            placeholder="First Name"
            wrapClasses="col-span-1"
          />
          <TextInput
            title={null}
            control={control}
            name="user.user_cs_payment_other.last_name"
            id="user.user_cs_payment_other.last_name"
            placeholder="Last Name"
            wrapClasses="col-span-1"
          />
        </article>
      ) : null}

      <RadioSelect
        title={
          <>
            Are you&nbsp;
            <span className="underline underline-offset-4">receiving</span>
            &nbsp;child support?
          </>
        }
        control={control}
        name="user.user_if_receiving_cs"
        id="user.user_if_receiving_cs"
        options={["yes", "no"]}
      />

      {watch("user.user_if_receiving_cs") === "yes" ? (
        <article className="grid grid-cols-2 gap-x-4">
          <Select
            // title={<p className="font-bold text-md col-span-2">Paid by:</p>}
            title="Paid by:"
            control={control}
            name="user.user_cs_receiving_from"
            id="user.user_cs_receiving_from"
            placeholder="Payment from"
            options={binaryWithOtherList}
          />

          <TextInput
            // title={
            //   <p className="font-bold text-md col-span-2">
            //     Weekly Payment Amount
            //   </p>
            // }
            title="Weekly Payment Amount"
            control={control}
            name="user.user_cs_receiving_amount"
            id="user.user_cs_receiving_amount"
            placeholder="Amount"
            isAmount
          />
        </article>
      ) : null}

      {watch("user.user_if_receiving_cs") === "yes" && watch("user.user_cs_receiving_from") === "other" ? (
        <article className="grid grid-cols-2 gap-x-4">
          <p className="font-bold text-sm col-span-2 mb-2">Payment from:</p>
          <TextInput
            title={null}
            control={control}
            name="user.user_cs_receiving_from_other.first_name"
            id="user.user_cs_receiving_from_other.first_name"
            placeholder="First Name"
            wrapClasses="col-span-1"
          />
          <TextInput
            title={null}
            control={control}
            name="user.user_cs_receiving_from_other.last_name"
            id="user.user_cs_receiving_from_other.last_name"
            placeholder="Last Name"
            wrapClasses="col-span-1"
          />
        </article>
      ) : null}
    </form>
  );
}
